import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import {
  PortalRegistry, usePortals, portalDetailPath,
  PORTAL_FACTORY_ROOT, PORTAL_CREATE_ROOT,
} from './olivium/portal-factory'

/**
 * Portal registry route wrapper.
 *
 *   /square/command-center/olivium/portals
 *
 * Owns the usePortals hook (live sq_project_portals list). Honest empty /
 * loading / auth / backend-not-migrated states — no fabricated portal rows.
 */
export default function SquareCodePortalRegistryRoute() {
  const navigate = useNavigate()
  const { portals, loading, error, authRequired } = usePortals()
  return (
    <PortalRegistry
      portals={portals}
      loading={loading}
      error={error}
      authRequired={authRequired}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenFactory={() => navigate(PORTAL_FACTORY_ROOT)}
      onCreatePortal={() => navigate(PORTAL_CREATE_ROOT)}
      onOpenPortal={(id) => navigate(portalDetailPath(id))}
    />
  )
}
